import SigliveServiceV1 from 'Service/sigliveServiceV1';

const patchTalkingPoint = async ({ payload, id }) => {
  const { data } = await SigliveServiceV1({ method: 'PATCH', url: `/briefs/talking-points/${id}`, data: payload });

  return data;
};

export default patchTalkingPoint;
